import PeopleIcon from '@mui/icons-material/People';
import { AnalyticsDashboard } from '../analytics/AnalyticsDashboard';

export default {
    list: AnalyticsDashboard,
    icon: PeopleIcon,
    options: { label: 'Leads' },
};
